import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSearchlinesSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSearchlinesSparkle"><Path d="M18.4 14H17.6L16.6 16.6L14 17.6V18.4L16.6 19.4L17.6 22H18.4L19.4 19.4L22 18.4V17.6L19.4 16.6L18.4 14Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M20 12H16.2266L15.0518 15.0518L12 16.2266V19.7734L15.0518 20.9473L15.457 22H4V2H20V12ZM12 11H7V9H12V11ZM15 7H7V5H15V7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSearchlinesSparkle;
